/* eslint-disable */
import React from 'react';
import { I18N_LANG_AR_AE, I18N_LANG_EN_AU, I18N_LANG_ZH_CN } from '../../Constants/I18n/I18n.constants';
import i18nStore from '../../Support/I18n/Store/I18nStore.support';

/* eslint-disable jsx-a11y/anchor-is-valid */

/**
 * The `key` to use to store the `translations`
 */
const key = `LoginPage`;

i18nStore.add(I18N_LANG_AR_AE, key, {
  Login: `تسجيل الدخول`,
  LoginError: `اسم المستخدم و / أو كلمة المرور غير صحيحين. الرجاء إدخال اسم المستخدم وكلمة المرور الخاصين بك`,
  PageHeading: ({ name }) => name,
  PageTitle: ({ name }) => `مرحبا بك في ${name}`,
  Password: `كلمه السر`,
  ResetPassword: `إعادة تعيين كلمة المرور`,
  TermsAndConditions: {
    Info: () => (
      <div>
        {` `} عن طريق تسجيل الدخول إلى Boral Connects فإنك توافق على
        <a href="#">الأحكام والشروط</a>
      </div>
    ),
    Read: `لقد قرأت الشروط والأحكام`,
  },
  UnauthorizedError: `لقد حاولت الوصول إلى صفحة تتطلب تصريحًا. الرجاء تسجيل الدخول للمتابعة.`,
  Username: `اسم المستخدم`,
});

i18nStore.add(I18N_LANG_EN_AU, key, {
  Login: `Login`,
  LoginError: `Your username and/or password is incorrect. Please enter your valid username and password`,
  PageHeading: ({ name }) => name,
  PageTitle: ({ name }) => `Welcome to ${name}`,
  Password: `Password`,
  ResetPassword: `Reset password`,
  TermsAndConditions: {
    Info: () => (
      <span>
        By signing in to Boral Connects you agree to the{` `}
        <a href="#" style={{ textDecoration: `underline` }}>
          Terms and conditions
        </a>
      </span>
    ),
    Read: `I have read the terms and conditions`,
  },
  UnauthorizedError: `You tried to access a page which requires authorisation. Please login to continue.`,
  Username: `Username`,
});

i18nStore.add(I18N_LANG_ZH_CN, key, {
  Login: `登录`,
  LoginError: `您的用戶名和/或密碼不正確。請輸入您的有效用戶名和密碼`,
  PageHeading: ({ name }) => name,
  PageTitle: ({ name }) => `歡迎來到 ${name}`,
  Password: `密码`,
  ResetPassword: `重设密码`,
  TermsAndConditions: {
    Info: () => (
      <div>
        登录Boral Connects即表示您同意{` `}
        <a href="#">条款和条件</a>
      </div>
    ),
    Read: `我已阅读条款和条件`,
  },
  UnauthorizedError: `您试图访问需要授权的页面。请登录访问更多内容。`,
  Username: `用戶名`,
});
